// project-imports
import {
  GET_YOUTUBE_CHANNEL_DATA_BEGIN,
  GET_YOUTUBE_CHANNEL_DATA_FAILURE,
  GET_YOUTUBE_CHANNEL_DATA_SUCCESS,
  GET_YOUTUBE_LATEST_VIDEO_BEGIN,
  GET_YOUTUBE_LATEST_VIDEO_FAILURE,
  GET_YOUTUBE_LATEST_VIDEO_SUCCESS,
  GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN,
  GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE,
  GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS,
} from "../constants/actions";

// State variable initialization
const initialState = {
  ytLoading: false,
  ytError: null,
  ytChannelData: {},
  ytlatestvideo: {},
  ytVideoCategories: {},
};

const youtubeReducer = (state = initialState, action) => {
  
  if (action.type === GET_YOUTUBE_CHANNEL_DATA_BEGIN) {
    // Set loading state
    return {
      ...state,
      ytLoading: action.payload,
      youtubeError: null,
    };
  }

  if (action.type === GET_YOUTUBE_CHANNEL_DATA_SUCCESS) {

    localStorage.setItem(
      "ytChannelData",
      JSON.stringify({
        ...state,
        ytLoading: false,
        ytChannelData: action.payload,
      })
    );

    // Update state with youtube channel data
    return {
      ...state,
      ytLoading: false,
      ytChannelData: action.payload,
    };
  }

  if (action.type === GET_YOUTUBE_CHANNEL_DATA_FAILURE) {
    // Set error state
    return {
      ...state,
      ytLoading: false,
      youtubeError: action.payload,
    };
  }

  if (action.type === GET_YOUTUBE_LATEST_VIDEO_BEGIN) {
    // Set loading state
    return {
      ...state,
      ytLoading: action.payload,
      youtubeError: null,
    };
  }

  if (action.type === GET_YOUTUBE_LATEST_VIDEO_SUCCESS) {
    localStorage.setItem(
      "ytlatestvideo",
      JSON.stringify({
        ...state,
        ytLoading: false,
        ytlatestvideo: action.payload,
      })
    );

    // Update state with latest video
    return {
      ...state,
      ytLoading: false,
      ytlatestvideo: action.payload,
    };
  }

  if (action.type === GET_YOUTUBE_LATEST_VIDEO_FAILURE) {
    // Set error state
    return {
      ...state,
      ytLoading: false,
      youtubeError: action.payload,
    };
  }

  if (action.type === GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN) {
    // Set loading state
    return {
      ...state,
      ytLoading: action.payload,
      youtubeError: null,
    };
  }

  if (action.type === GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS) {

    // Update state with all youtube categories 
    return {
      ...state,
      ytLoading: false,
      ytVideoCategories: action.payload,
      youtubeError: null,
    };
  }

  if (action.type === GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE) {
    // Set error state
    return {
      ...state,
      ytLoading: false,
      youtubeError: action.payload,
    };
  }

  return state;
};

export default youtubeReducer;
